module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-md-11 col-md-offset-1 col-xs-12\">\n      <div class=\"videos\">\n        <p class=\"title\">My Course Recordings</p>\n          <mp-resource-groups [resourceType]=\"videoResourceType\"></mp-resource-groups>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/video-resources/video-resources.html
// module id = a//D
// module chunks = 3